// extracted by mini-css-extract-plugin
export default {"chip":"Chip_chip__o+jAe","chip__text":"Chip_chip__text__uU35M","chip__icon":"Chip_chip__icon__3n4NX"};